<template>
  <gli-button v-bind="$attrs" v-on="$listeners" v-if="canEdit">
    <template>
      <slot name="default" />
    </template>
  </gli-button>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  name: 'GliEditorButton',

  computed: {
    ...mapGetters('account', ['canEdit'])
  },

  methods: {}
};
</script>
